import React from 'react'
import useStore from '../../../../BusinessStore/Store'
import styles from './styles.module.css'
import uploadIcon from '../../../../../img/uploadSVG.svg'

function FranchiseLocations () {
  const {
    isQueryLoading,
    setCountry,
    setName
  } = useStore()

  const onClickStarBucks = () => {
    if (isQueryLoading) return
    setName('Starbucks')
  }
  const onClickSubwayLocation = () => {
    if (isQueryLoading) return
    setName("Subway”")
    setCountry('US')
  }
  const onClickTacoBellLocation = () => {
    if (isQueryLoading) return
    setName("Taco Bell")
    setCountry('US')
  }

  return (
    <section>
      <div className={styles.jobTitlePeopleContainer}>
        <h2 className={styles.jobTitlePeopleTitle}>Franchise locations</h2>
        <div className={styles.jobTitlePeopleValues}>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickStarBucks}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>Starbucks</span>
              <p className={styles.jobTitlePeopleText}>
                Starbucks locations across the world
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickSubwayLocation}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>Subways in the US</span>
              <p className={styles.jobTitlePeopleText}>
              Subway locations in the US
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickTacoBellLocation}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>Taco Bells in the US</span>
              <p className={styles.jobTitlePeopleText}>
              Taco Bell locations in the US
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default FranchiseLocations
